import { createSlice } from '@reduxjs/toolkit';

// Drawer 상태 관리(전역 상태 초기값)
let initialState = {
  open: false,
  appBarTitle: 'SafeOn',
  changedYn: 'Y',
};

// Reducer 정의
const DrawerSlice = createSlice({
  name: 'Drawer',
  initialState, // reducers 함수(액션 생성자)의 매개변수
  reducers: {
    OpenDrawer(state) {
      // Drawer 열림
      state.open = true;
    },
    CloseDrawer(state) {
      // Drawer 닫힘
      state.open = false;
    },
    setUseOpen(state) {
      // Drawer 열림 가능
      state.changedYn = 'Y';
    },
    setNotOpen(state) {
      // Drawer 열림 불가능(알림창)
      state.changedYn = 'N';
    },
  },
});

export const DrawerActions = DrawerSlice.actions; // 컴포넌트에서 액션을 dispatch할 때 사용(ex. dispatch(DrawerActions.OpenDrawer()))
export default DrawerSlice.reducer;
